<template>
<div>
    <moo-popover popper-class="common-popper create-popper" placement="bottom-end" width="184" trigger="hover" :close-delay="0" v-model="addVisible" :disabled="readOnly">
      <div class="create-file-popper" v-if="!isRead">
        <span :class="{ 'upload-tip': data.type === 'UPLOAD' }" @click="(event) => handleCreate(data.type)" :key="data?.icon" v-for="data in createOptions">
          <div :class="[
              'create-tip',
              isSupportCreate(data) === false ? 'create-tip-disable' : '',
            ]">
            <svg-icon class-name="file-icon" :icon-class="data.icon"></svg-icon>
            {{ data?.resourceName }}
            <svg-icon v-if="data.type === 'UPLOAD'" class-name="upload-file" icon-class="arrow-right"></svg-icon>
          </div>
          <div v-if="data.type === 'UPLOAD'" ref="uploadPopper" class="upload-popper">
            <span @click="(event) => handleUpload(data.type)" :key="data?.icon" v-for="data in uploadOptions">
              <svg-icon class-name="file-icon" :icon-class="data.icon"></svg-icon>
              {{ data.name }}
            </span>
          </div>
        </span>
      </div>
      <svg-icon v-if="this.isHeader" slot="reference" class-name="header-icon" icon-class="add-file" :class="[readOnly === true ? 'header-icon-readonly' : '']"></svg-icon>
      <div v-else :class="{ 'common-btn': true, 'disabled-btn': isRead }" slot="reference">
      <moo-tooltip :content="$t('权限不足，无法上传/新建#!!!#src/pages/H5/Cloud/components/popper/CreatePopper.vue_1')" effect="light" :visible-arrow="false" popper-class="no-auth-tooltip-class" placement="bottom" :disabled="isRead === false">
        <div class="upload-content">{{$t("新建#!!!#src/pages/H5/Cloud/components/popper/CreatePopper.vue_1")}}            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8.21428571 4.64285714" class="download-btn-icon design-iconfont">
            <path id="file-unselected-svg" d="M2.65690708,8.3711928 C2.44769764,8.58040224 2.44769764,8.91959776 2.65690708,9.1288072 C2.86611652,9.33801665 3.20531205,9.33801665 3.41452149,9.1288072 L6.98595006,5.55737863 C7.1951595,5.34816919 7.1951595,5.00897367 6.98595006,4.79976422 L3.41452149,1.22833565 C3.20531205,1.01912621 2.86611652,1.01912621 2.65690708,1.22833565 C2.44769764,1.43754509 2.44769764,1.77674062 2.65690708,1.98595006 L5.84952845,5.17857143 L2.65690708,8.3711928 Z" fill="#646A73" fill-rule="nonzero" transform="rotate(90 5.892857 3.392856)"></path>
            </svg>
        </div>
        </moo-tooltip>
      </div>
    </moo-popover>
  </div>
</template>

<script>
import { intl } from 'tci18n-vue2'
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  props: {
    rootId: {
      type: String
    },
    fileId: {
      type: String
    },
    metadata: {
      type: Object
    },
    isHeader: {
      type: Boolean,
      default: true
    },
    isRead: {
      type: Boolean,
      default: false
    },
    editorMode: {
      type: String,
      default: "PREVIEW"
    }
  },
  name: "CreatePopper",
  components: {},
  data() {
    return {
      addVisible: false,
      headerAdd: [
      {
        resourceName: intl.$t("新建文档#!!!#src/pages/H5/Cloud/components/popper/CreatePopper.vue_1"),
        icon: "cloud-online-doc",
        type: "DOCUMENT"
      },
      {
        resourceName: intl.$t("新建表格#!!!#src/pages/H5/Cloud/components/popper/CreatePopper.vue_1"),
        icon: "file-excel",
        type: "EXCEL"
      },
      {
        resourceName: intl.$t("新建演示文稿#!!!#src/pages/H5/Cloud/components/popper/CreatePopper.vue_1"),
        icon: "file-ppt",
        type: "PPT"
      },
      {
        resourceName: intl.$t("新建office文档#!!!#src/pages/H5/Cloud/components/popper/CreatePopper.vue_1"),
        icon: "file-wps",
        type: "WORD"
      }
      // {
      //     resourceName: '上传',
      //     icon: 'cloud-online-upload',
      //     type: 'UPLOAD'
      // },
      ],
      uploadOptions: [
      {
        name: intl.$t("上传文件#!!!#src/pages/H5/Cloud/components/popper/CreatePopper.vue_1"),
        icon: "file-upload",
        type: "file"
      },
      {
        name: intl.$t("上传文件夹#!!!#src/pages/H5/Cloud/components/popper/CreatePopper.vue_1"),
        icon: "folder-upload",
        type: "folder"
      }]

    };
  },
  methods: {
    handleCreate(value) {
      if (this.canCreateContentTypes?.includes(value) === false) {
        this.addVisible = false;
        return;
      }
      if (value == "FOLDER") {
        this.$emit("handleFolderDialog", true);
        return;
      }
      if (value == "UPLOAD") {
        return;
      }
      this.$emit("handleCreate", value);
      this.addVisible = false;
    },
    handleUpload(value) {
      this.$emit("handleUpload", value);
      this.addVisible = false;
    },
    isSupportCreate(menuItem) {
      return this.canCreateContentTypes?.includes(menuItem.type);
    }
  },
  computed: {
    ...mapState({
      wikiSpaceInfo: (state) => state.wikiSpaceInfo
    }),
    canCreateContentTypes() {
      return this.wikiSpaceInfo?.wikiSpaceSettings?.canCreateContentTypes;
    },
    readOnly() {
      if (this.isHeader === false) {
        return this.isRead === true;
      }
      return this.wikiSpaceInfo?.wikiSpaceSettings?.readOnly;
    },
    createOptions() {
      if (this.isHeader) {
        if (this.metadata && this.metadata.productType === "CLOUD_DOCUMENT") {
          return this.headerAdd.filter((item) => item.type !== "UPLOAD");
        }
        return this.headerAdd;
      }
      return [
      ...this.headerAdd.filter((item) => item.type !== "UPLOAD"),
      {
        resourceName: intl.$t("新建文件夹#!!!#src/pages/H5/Cloud/components/popper/CreatePopper.vue_1"),
        icon: "cloud-folder",
        type: "FOLDER"
      }];

    }
  },
  watch: {},
  mounted() {},
  destroyed() {}
};
</script>

<style lang="scss" scoped>
.common-popper {
  width: 146px !important;
  padding: 4px 4px !important;
  height: 112px;
  background: #ffffff;
  border: 1px solid #e6e8ec !important;
  box-shadow: 0 8px 12px 0 #1213171a !important;
  border-radius: 8px !important;
  box-sizing: border-box;
  height: auto !important;
  width: 146px !important;
  margin-top: 8px !important;

  .popper__arrow {
    display: none !important;
  }
}

.common-popper.create-popper {
  width: 180px !important;
  margin-top: 8px !important;
}

.header-icon-readonly {
  cursor: not-allowed !important;
}

.header-icon {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  width: 16px !important;
  height: 16px !important;
  outline: none !important;
}

.header-icon:hover {
  background: #f4f6f9;
  border-radius: 4px;
}

.common-btn {
  margin-left: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 62px;
  height: 26px;
  background: #ffffff;
  cursor: pointer;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 13px;
  color: #222329;
  letter-spacing: 0;
  border: 1px solid #e8e9ee;
  border-radius: 4px;

  .download-btn-icon {
    width: 12px;
    height: 12px;
    margin-left: 4px;
  }

  &:hover {
    background: #f4f6f9;
  }

  .upload-content {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.disabled-btn {
  background: #f4f6f9 !important;
  user-select: none;
  position: relative;
  color: #ced5fe;

  .download-btn-icon {
    #file-unselected-svg {
      fill: #ced5fe !important;
    }
  }

  .no-auth {
    display: none;
    position: absolute;
    bottom: -48px;
    right: -2px;
    line-height: 33px;
    text-align: center;
    width: 170px;
    height: 33px;
    background: #ffffff;
    border: 1px solid #e8e9ee;
    box-shadow: 0 8px 16px 0 #1213171a;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 12px;
    color: #121317;
  }
}

.disabled-btn:hover {
  .no-auth {
    display: block;
  }
}

.create-file-popper {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: flex-end;

  .upload-popper {
    display: none;
    position: absolute;
    width: 170px;
    height: auto;
    left: -160px;
    top: 0;
    background: #ffffff;
    border: 1px solid #e6e8ec;
    box-shadow: 0 8px 12px 0 #1213171a;
    border-radius: 8px;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    padding: 4px;

    span {
      justify-content: flex-start;

      &:hover {
        background: #f4f6f9;
      }
    }

    &:hover {
      display: flex;
    }
  }

  .upload-tip {
    width: 200px;
  }

  .upload-tip:hover {
    .upload-popper {
      display: flex;
    }
  }

  span {
    font-weight: 400;
    font-size: 14px;
    color: #222329;
    letter-spacing: 0;
    width: 100%;
    height: 40px;
    border-radius: 8px;
    line-height: 16px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    cursor: pointer;
    position: relative;

    .create-tip-disable {
      cursor: not-allowed !important;
    }

    .create-tip {
      width: 170px;
      height: 100%;
      background: #ffffff;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      border-radius: 8px;

      &:hover {
        background: #f4f6f9;
      }
    }

    .file-icon {
      cursor: pointer;
      width: 24px;
      height: 24px;
      margin: 0 8px;
      flex-shrink: 0;
    }

    .upload-file {
      width: 16px;
      height: 16px;
      margin: 0 8px;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 8px;
      margin: auto 0;
      flex-shrink: 0;
    }
  }
}
</style>

<style lang="scss">
.no-auth-tooltip-class {
    border-radius: 8px !important;
    color: #767c85;
    font-size: 14px !important;
    font-weight: 400;
    padding: 8px !important;
    background-color: #fff !important;
    box-shadow: 0 8px 12px 0 #1213171a !important;
    border: none !important;
    line-height: 24px !important;
    margin-top: 18px !important;
    word-break: keep-all !important;
    text-align: center !important;
}
</style>
